(() => {
  function triggerPushChanges(props) {
    const {
      event,
      currentProduct,
      prodInfo,
      quantityDelta,
    } = props;
    const isCartPage = App.settings.pageType === 'CART_PAGE';
    const lensPackageSKU = isCartPage
      ? currentProduct.isLens && currentProduct.selectedArticle.packageSKU
      : null;
    const productId = isCartPage
      ? currentProduct.productID
      : currentProduct.id;
    /* eslint-disable no-param-reassign */
    prodInfo.packageSKU = TrackApp.getPackageSKU(productId, lensPackageSKU);
    prodInfo.quantity = quantityDelta || currentProduct.quantity || 1;
    /* eslint-enable no-param-reassign */

    $(document).trigger('uaPushChanges', { event, prodInfo });
  }

  async function trackGatherData(props) {
    if (TrackApp.disabled) return TrackApp.mockTrackingApp;

    const {
      currentProduct,
      event,
      quantityDelta = null,
    } = props;
    const productsData = [{
      productId: App.settings.pageType === 'CART_PAGE' ? currentProduct.productID : currentProduct.id,
      quantity: currentProduct.quantity,
    }];
    const { productInformation } = await TrackApp.fetch({ productsData });
    const [prodInfo] = productInformation;
    triggerPushChanges({
      event,
      prodInfo,
      currentProduct,
      quantityDelta,
    });

    return TrackApp.mockTrackingApp;
  }

  /**
   * Analytics may have several records with the same product: with normal price and zero price -
   * due to behaviours, for ex. n-th product for free.
   */
  const filterAnalyticsProduct = ({ analyticsProdInfo, cartItem }) => {
    if (!analyticsProdInfo) { return null; }

    const allAnalyticsProducts = analyticsProdInfo.filter((p) => (
      cartItem.type === App.product.Type.LENS
        ? p.packageSKU === cartItem.selectedArticle.packageSKU
        : p.productId === cartItem.productID
    ));
    const analyticsProductsWithPrice = allAnalyticsProducts.filter((p) => (
      Number.parseFloat(p.price) > 0
    ));

    return analyticsProductsWithPrice.length
      ? analyticsProductsWithPrice[0]
      : allAnalyticsProducts[0];
  };

  function uaAddCartItem(props) {
    const {
      event,
      analyticsProduct = null,
      currentProduct,
      quantityDelta = null,
    } = props;

    if (analyticsProduct) {
      triggerPushChanges({
        event,
        prodInfo: analyticsProduct,
        currentProduct,
        quantityDelta,
      });
      return TrackApp.mockTrackingApp;
    }

    return trackGatherData(props);
  }

  function uaRemoveCartItem(props) {
    const {
      event, cartItem, quantityDelta,
    } = props;
    const lensPackageSKU = cartItem.type === 'LENS' && cartItem?.selectedArticle?.packageSKU;
    const product = {
      id: cartItem.productID,
      groupId: cartItem.groupID || '',
      name: cartItem.name,
      category: cartItem.type,
      categoryNameId: cartItem.categoryNameId || 'N/A',
      subCategory: cartItem.factType || 'N/A',
      manufacturer: cartItem.brand || 'N/A',
      packageSKU: TrackApp.getPackageSKU(cartItem.productID, lensPackageSKU),
      price: Math.round((cartItem.price / ua.VAT) * 100) / 100,
      quantity: quantityDelta || cartItem.quantity,
    };
    dataLayer.push({
      event,
      product,
    });

    return TrackApp.mockTrackingApp;
  }

  /**
   * @function uaUpdateCart
   * @description - track cart state after cartAdd or cartRemove events
   * @param {Array} analyticsProdInfo - analytics information
   * @returns {Object} mockTrackingApp - mocked object with Deferred callbacks
   */
  function uaUpdateCart(analyticsProdInfo) {
    if (TrackApp.disabled) return TrackApp.mockTrackingApp;

    const cart = analyticsProdInfo.map((analyticsInfo) => (
      {
        id: analyticsInfo.productId,
        groupId: analyticsInfo.groupId || '',
        name: analyticsInfo.name,
        category: analyticsInfo.category,
        categoryNameId: analyticsInfo.categoryNameId || 'N/A',
        subCategory: analyticsInfo.subcategory || 'N/A',
        manufacturer: analyticsInfo.manufacturer || 'N/A',
        availability: analyticsInfo.stockState || 'N/A',
        price: Math.round((analyticsInfo.price / ua.VAT) * 100) / 100,
        quantity: analyticsInfo.inCartQuantity,
        ribbon: TrackApp.getRibbon(analyticsInfo),
        packageSKU: TrackApp.getPackageSKU(analyticsInfo.productId, analyticsInfo.packageSKU),
      }
    ));

    dataLayer.push({
      event: 'cartUpdate',
      cart,
    });

    return TrackApp.mockTrackingApp;
  }

  /**
   * @function trackCartPageEvent
   * @description - track cart state after cartAdd or cartRemove events
   * @param {String} event - event name
   * @param {Object} cartItem - cart item
   * @param {Object} updateCartResp - updateCart/deleteFromCart cart services response
   * @param {Number} quantityDelta - item quantity that has been added/removed
   * @returns {Object} mockTrackingApp - mocked object with Deferred callbacks
   */
  function trackCartPageEvent(event, cartItem, updateCartResp = null, quantityDelta = null) {
    if (TrackApp.disabled) return TrackApp.mockTrackingApp;

    let jqxhr = null;
    const analyticsProdInfo = updateCartResp
      ? updateCartResp.analyticsInformation.productInformation
      : null;

    if (event === 'cartAdd') {
      jqxhr = uaAddCartItem({
        event,
        currentProduct: cartItem,
        quantityDelta,
        analyticsProduct: filterAnalyticsProduct({ analyticsProdInfo, cartItem }),
      });
    } else if (event === 'cartRemove') {
      jqxhr = uaRemoveCartItem({
        event, cartItem, quantityDelta,
      });
    }

    if (jqxhr && analyticsProdInfo) {
      return jqxhr.always(() => {
        uaUpdateCart(analyticsProdInfo);
      });
    }
    return TrackApp.mockTrackingApp;
  }

  function initCheckoutStepTracking() {
    const $kcc = $('#klarna-checkout-container');
    const $cartDetailsForm = $('.cart-page__my-details-form');
    const $elem = $kcc.length ? $kcc : $cartDetailsForm;
    let i = 0;

    function trackCheckoutStep() {
      if (i !== 0) {
        $(window).off('scroll', trackCheckoutStep);
        return;
      }
      const $this = $(this);
      if ($elem.is(':visible') && $this.scrollTop() > $elem.offset().top - $this.height()) {
        dataLayer.push({
          event: 'checkoutStep',
          step: 2,
        });
        i += 1;
      }
    }

    $(window).on('scroll', trackCheckoutStep);
  }

  if (App.settings.pageType === 'CART_PAGE') {
    initCheckoutStepTracking();
  }

  window.TrackApp.trackCartPageEvent = trackCartPageEvent;
})();
